import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { DialogCloseReason, SuiDialogBase } from '@sui/dialog';
import { UtilsService } from 'src/app/core/services/utils.service';

interface InvitationLinkDialogData {
  link: string;
}
interface InvitationLinkDialogResult {}

@Component({
  selector: 'app-invitation-link-dialog',
  standalone: false,
  templateUrl: './invitation-link-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './invitation-link-dialog.component.scss',
})
export class InvitationLinkDialogComponent extends SuiDialogBase<
  InvitationLinkDialogData,
  InvitationLinkDialogResult
> {
  private translateService = inject(TranslateService);
  private utilsService = inject(UtilsService);

  title = this.translateService.instant('invitation-link-dialog.title');

  get link(): string {
    return this.dialogData.link;
  }

  cancel(): void {
    this.close({ reason: DialogCloseReason.Cancel });
  }

  copyToClipboard(): void {
    this.utilsService.copyToClipboard(this.link);
  }
}
